//Upload.js
import React from 'react'
import { Container, Typography } from '@mui/material';
import Upload from '../components/upload';
import { Link } from 'react-router-dom';
const ImgUpload = () => {
    return (
        <div>

            <Typography variant="h4" align="center" gutterBottom>
                Upload
            </Typography>
            <Upload />
            <Link to="/retrive">Retrieve File</Link>
        </div>
    )
}

export default ImgUpload